import {InputDate} from '@/components/commons/input-date-legacy/InputDate'
import {InputText} from '@/components/commons/input-text/InputText'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {Controller, useFormContext} from 'react-hook-form'
import {UserProfessionalRegisterFormValidationSchema} from '@/features/users/types'

export const UserProfessionalRegisterForm = () => {
    const {t} = useTranslation()
    const form = useFormContext<UserProfessionalRegisterFormValidationSchema>()

    return (
        <Grid columns={6} fullWidth gap={4}>
            <GridItem spanColumn={2}>
                <InputText
                    type="text"
                    label={t('users:professional_register_number')}
                    placeholder="12345678"
                    {...form.register('registrationNumber')}
                />
            </GridItem>
            <GridItem spanColumn={2}>
                <InputText
                    type="text"
                    label={t('users:professional_register_location')}
                    placeholder={t('users:professional_register_location_placeholder')}
                    errorMessage={form.formState.errors.registrationLocation?.message}
                    {...form.register('registrationLocation')}
                />
            </GridItem>
            <GridItem spanColumn={2}>
                <Controller
                    name="registrationDate"
                    control={form.control}
                    render={({field}) => (
                        <InputDate
                            label={'Data iscrizione albo'}
                            placeholder="GG/MM/AAAA"
                            errorMessage={form.formState.errors.registrationDate?.message}
                            maxDate={dayjs().toDate()}
                            numMonths={1}
                            fullWidth
                            selectedDates={field.value ? [field.value] : []}
                            onChange={field.onChange}
                        />
                    )}
                />
            </GridItem>
        </Grid>
    )
}
